import { render, staticRenderFns } from "./GenericErrorDialogV2.vue?vue&type=template&id=108b1e70&scoped=true"
import script from "./GenericErrorDialogV2.vue?vue&type=script&lang=js"
export * from "./GenericErrorDialogV2.vue?vue&type=script&lang=js"
import style0 from "./GenericErrorDialogV2.vue?vue&type=style&index=0&id=108b1e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108b1e70",
  null
  
)

export default component.exports